import { useEffect, useState } from 'react';

/** Phone breakpoint; matches the `max-width: 767.98px` CSS media queries. */
export const MOBILE_MQ = '(max-width: 767.98px)';

function readMatches(query) {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  try {
    const mq = window.matchMedia(query);
    return Boolean(mq && mq.matches);
  } catch {
    return false;
  }
}

/**
 * Subscribe to a media query. Defaults to false on SSR / missing matchMedia.
 */
export function useMatchMedia(query = MOBILE_MQ) {
  const [matches, setMatches] = useState(() => readMatches(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    let mq;
    try {
      mq = window.matchMedia(query);
    } catch {
      return undefined;
    }
    if (!mq) return undefined;

    const onChange = () => setMatches(Boolean(mq.matches));
    onChange();
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    }
    if (typeof mq.addListener === 'function') {
      mq.addListener(onChange);
      return () => mq.removeListener(onChange);
    }
    return undefined;
  }, [query]);

  return matches;
}

export function useIsMobileMd() {
  return useMatchMedia(MOBILE_MQ);
}
